import { createSlice } from "@reduxjs/toolkit";
import apiSlice from "../../app/api/apiSlice";

const initialState = { user: null };

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		setCredentials: (state, action) => {
			state.user = action.payload.user;
		},
		logOut: (state) => {
			state.user = null;
		},
		extraReducers: (builder) => {
			builder.addCase(
				apiSlice.endpoints.logout.matchFulfilled,
				(state, action) => {
					apiSlice.util.resetApiState();
				}
			);
		},
	},
});

export const { setCredentials, logOut } = authSlice.actions;

export const selectCurrentUser = (state) => state.auth.user;

export default authSlice.reducer;
